import { useMemo } from 'react';

import { Meteors } from './Meteors';

interface Star {
  id: number;
  x: number;
  y: number;
  size: number;
  opacity: number;
  delay: number;
  duration: number;
}

function rand(min: number, max: number) {
  return min + Math.random() * (max - min);
}

function shuffle<T>(items: T[]) {
  const next = [...items];
  for (let i = next.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [next[i], next[j]] = [next[j]!, next[i]!];
  }
  return next;
}

function createSpreadStars(count: number): Star[] {
  const cols = 10;
  const rows = 7;
  const cells = shuffle(
    Array.from({ length: cols * rows }, (_, index) => ({
      col: index % cols,
      row: Math.floor(index / cols),
    })),
  ).slice(0, count);

  const xPad = 5;
  const yPad = 3;
  const xSpan = 100 - xPad * 2;
  const ySpan = 46 - yPad * 2;

  return cells.map((cell, id) => {
    const cellW = xSpan / cols;
    const cellH = ySpan / rows;
    const x = xPad + cell.col * cellW + rand(cellW * 0.15, cellW * 0.85);
    const y = yPad + cell.row * cellH + rand(cellH * 0.15, cellH * 0.85);

    return {
      id,
      x,
      y,
      size: rand(1.3, 3.6),
      opacity: rand(0.35, 0.95),
      delay: rand(0, 5),
      duration: rand(2.4, 5.8),
    };
  });
}

/** Twinkling stars + subtle meteors in the upper sky band. */
export function AuthSkyStars() {
  const stars = useMemo(() => createSpreadStars(62), []);

  return (
    <div className="auth-sky-stars" aria-hidden="true">
      {stars.map((star) => (
        <span
          key={star.id}
          className="auth-sky-star"
          style={{
            left: `${star.x}%`,
            top: `${star.y}%`,
            width: `${star.size}px`,
            height: `${star.size}px`,
            ['--star-base-opacity' as string]: star.opacity,
            animationDelay: `${star.delay}s`,
            animationDuration: `${star.duration}s`,
          }}
        />
      ))}
      <div className="auth-sky-meteors">
        <Meteors
          number={4}
          minDelay={0}
          maxDelay={20}
          minDuration={4.2}
          maxDuration={7.5}
          minPause={8}
          maxPause={26}
        />
      </div>
    </div>
  );
}
